/* eslint-disable no-underscore-dangle */
import { forwardRef, useEffect, useState, useContext } from 'react';
import PropTypes from 'prop-types';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { ChatContext } from '../../contexts/ChatContext';
import { Box } from '@material-ui/core';

const Scrollbar = forwardRef((props, ref) => {
  const { children, ...other } = props;
  // eslint-disable-next-line no-unused-vars
  const [scrollHeight, setScrollHeight] = useState(0);
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

  const context = useContext(ChatContext);
  const { setScrollCount, isLoading, isFinish } = context;

  const handleScroll = (container) => {
    if (((scrollHeight - container.scrollTop) >= scrollHeight * (2 / 3)) && !isLoading && !isFinish) {
      setScrollHeight(container.scrollTop);
      setScrollCount((value) => value + 1);
    }
  };

  useEffect(() => {
    if (ref !== null) {
      setScrollHeight(ref.current._container.scrollHeight);
    }
  }, [ref]);

  if (isMobile) {
    return (
      <Box
        ref={ref}
        sx={{ overflowX: 'auto' }}
      >
        {children}
      </Box>
    );
  }

  return (
    <PerfectScrollbar
      ref={ref}
      {...other}
      onScrollY={handleScroll}
    >
      {children}
    </PerfectScrollbar>
  );
});

Scrollbar.propTypes = {
  children: PropTypes.node
};

export default Scrollbar;
